// extracted by mini-css-extract-plugin
module.exports = {"overlayClass":"WhiteUserFrontControl_overlayClass__DN2AV","tag":"WhiteUserFrontControl_tag___cePg","tagActive":"WhiteUserFrontControl_tagActive__Egg_k"};